var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.oneUser)?_c('header-app'):_vm._e(),_c('v-content',[_c('router-view')],1),(!_vm.is_mobile)?_c('footer-app'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }